import { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { coreSelectors } from '@ucheba/store/core'
import { useDialog } from '@ucheba/ui/components/Dialog/bll'
import { IDialog } from '@ucheba/ui/components/Dialog/types'
import { IAdmissionSupportPageCaseCardProps, IAdmissionSupportPageProps } from './types'
import ImgCard1 from './assets/img__card-1-desktop.png'
import ImgCard2 from './assets/img__card-2-desktop.png'
import ImgCard3 from './assets/img__card-3-desktop.png'
import ImgCard4 from './assets/img__card-4-desktop.png'
import ImgCard5 from './assets/img__card-5-desktop.png'
import ImgCard6 from './assets/img__card-6-desktop.png'
import ImgCardTouch1 from './assets/img__card-1-touch.png'
import ImgCardTouch2 from './assets/img__card-2-touch.png'
import ImgCardTouch3 from './assets/img__card-3-touch.png'
import ImgCardTouch4 from './assets/img__card-4-touch.png'
import ImgCardTouch5 from './assets/img__card-5-touch.png'
import ImgCardTouch6 from './assets/img__card-6-touch.png'

export const useListCardsImage = (
  list: IAdmissionSupportPageProps['content']['mistakes']['cards']
): {
  title: string
  text: string
  img: string
}[] => {
  const isTouch = useSelector(coreSelectors.isTouch)

  return useMemo(() => {
    const getImage = (key: number): string => {
      switch (key) {
        case 0:
          return isTouch ? ImgCardTouch1 : ImgCard1
        case 1:
          return isTouch ? ImgCardTouch2 : ImgCard2
        case 2:
          return isTouch ? ImgCardTouch3 : ImgCard3
        case 3:
          return isTouch ? ImgCardTouch4 : ImgCard4
        case 4:
          return isTouch ? ImgCardTouch5 : ImgCard5
        case 5:
          return isTouch ? ImgCardTouch6 : ImgCard6
        default:
          return ''
      }
    }

    return list.map((item, key) => ({
      ...item,
      img: getImage(key),
    }))
  }, [list, isTouch])
}

interface IUseCasesCore {
  (): {
    selectedCase: IAdmissionSupportPageCaseCardProps['selectedCase'] | undefined
    onClickCase: (data: IAdmissionSupportPageCaseCardProps['card']) => void
    dialog: IDialog
  }
}

export const useCasesCore: IUseCasesCore = () => {
  const dialog = useDialog('selectedCaseDialogId')

  const [selectedCase, setSelectedCase] = useState<
    IAdmissionSupportPageCaseCardProps['selectedCase'] | undefined
  >(undefined)

  const onClickCase = useCallback(
    (data: IAdmissionSupportPageCaseCardProps['card']) => {
      setSelectedCase(data)

      dialog.openDialog()
    },
    [dialog]
  )

  return {
    onClickCase,
    selectedCase,
    dialog,
  }
}
